import { Skeleton } from "@mui/material";
import React from "react";
import {
  CurrentCount,
  MainContainerDiv,
  MainContainerHeading,
} from "./Dashboard.style";

const DashboardPart = ({ DashboardHeading, DashboardValue, Icon, style, isLoading }) => {

  return (
    <>
      <MainContainerDiv style={style}>
        <div>
          <MainContainerHeading>{DashboardHeading}</MainContainerHeading>

          {isLoading ? (
            <CurrentCount>
              {/* <SyncLoader color="#4e97fd" size={8} /> */}
              <Skeleton animation="wave" />
            </CurrentCount>
          ) : (
            <CurrentCount>{DashboardValue}</CurrentCount>
          )}
        </div>
        <div>
          <img
            style={{
              height: "6rem",
              width: "6rem",
            }}
            src={Icon}
            alt=""
          />
        </div>
      </MainContainerDiv>
    </>
  );
};

export default DashboardPart;
